// @ts-nocheck
import React, { useState, useEffect } from "react";
import { supabase } from "../../../services/supabaseClient";
import { useAuth } from "../../../context/AuthContext"; // ✅ added
import "../MyAccountModal.css";

interface BrokerConnectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BrokerConnectionModal: React.FC<BrokerConnectionModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { user } = useAuth();                // ✅ added
  const authId = user?.id;                   // ✅ added

  const [brokers, setBrokers] = useState<any[]>([]);
  const [connectedBrokers, setConnectedBrokers] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    if (isOpen) {
      loadData();
      setStatusMessage("");
    }
  }, [isOpen]);

  const loadData = async () => {
    if (!authId) return; // ✅ safety
    setLoading(true);

    const { data: allBrokers } = await supabase
      .from("brokers")
      .select("filer_code, broker_name");

    const { data: connections } = await supabase
      .from("user_brokers")
      .select("filer_code")
      .eq("auth_id", authId);

    const connectedCodes = connections?.map((c) => c.filer_code) || [];

    setBrokers(allBrokers || []);
    setConnectedBrokers(
      allBrokers?.filter((b) => connectedCodes.includes(b.filer_code)) || []
    );

    setLoading(false);
  };

  const handleAddConnection = async (filerCode: string) => {
    if (!authId) return; // ✅ safety
    setSaving(true);
    const { error } = await supabase
      .from("user_brokers")
      .insert([{ auth_id: authId, filer_code: filerCode }]);
    if (error) console.error("Insert error:", error.message);
    setStatusMessage("✓ Connected");
    fadeStatus();
    await loadData();
    setSaving(false);
  };

  const handleRemoveConnection = async (filerCode: string) => {
    if (!authId) return;
    setSaving(true);
    const { error } = await supabase
      .from("user_brokers")
      .delete()
      .match({ auth_id: authId, filer_code: filerCode });
    if (error) console.error("Delete error:", error.message);
    setStatusMessage("✕ Removed");
    fadeStatus();
    await loadData();
    setSaving(false);
  };

  const fadeStatus = () => setTimeout(() => setStatusMessage(""), 1600);

  const filteredBrokers = brokers.filter((b) =>
    b.broker_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="my-account-modal-overlay" onClick={onClose}>
      <div className="my-account-modal" onClick={(e) => e.stopPropagation()}>
        <div className="my-account-modal-header">
          <h2 className="my-account-modal-title">Broker Connections</h2>
          <button className="my-account-modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="my-account-modal-content">
          <div className="form-group">
            <label className="form-label">Search Brokers</label>
            <input
              type="text"
              className="form-input"
              placeholder="Search by broker name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {statusMessage && (
            <div className="connection-status">{statusMessage}</div>
          )}

          {loading ? (
            <div className="connection-loading">Loading...</div>
          ) : (
            <div className="connection-list">
              {filteredBrokers.map((broker) => {
                const isConnected = connectedBrokers.some(
                  (b) => b.filer_code === broker.filer_code
                );
                return (
                  <div key={broker.filer_code} className="connection-list-item">
                    <span>{broker.broker_name}</span>
                    <div className="connection-actions">
                      {isConnected ? (
                        <button
                          onClick={() =>
                            handleRemoveConnection(broker.filer_code)
                          }
                          className="remove-btn"
                          disabled={saving}
                        >
                          Remove
                        </button>
                      ) : (
                        <button
                          onClick={() => handleAddConnection(broker.filer_code)}
                          className="add-btn"
                          disabled={saving}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
              {filteredBrokers.length === 0 && (
                <div className="connection-empty">
                  No matching brokers found.
                </div>
              )}
            </div>
          )}
        </div>

        <div className="my-account-modal-footer">
          <button className="my-account-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrokerConnectionModal;
